import { render } from "./ContactInformationForm.vue?vue&type=template&id=e8bf4094"
import script from "./ContactInformationForm.vue?vue&type=script&lang=js"
export * from "./ContactInformationForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__